import { render, staticRenderFns } from "./preset.vue?vue&type=template&id=5948803c&scoped=true&"
import script from "./preset.vue?vue&type=script&lang=js&"
export * from "./preset.vue?vue&type=script&lang=js&"
import style0 from "./preset.vue?vue&type=style&index=0&id=5948803c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5948803c",
  null
  
)

export default component.exports